
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 11","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 9.5l8-8","stroke":"currentColor","stroke-width":"1.5","vector-effect":"non-scaling-stroke"}}),_c('path',{attrs:{"d":"M1 1.5l8 8","stroke":"currentColor","stroke-width":"1.5","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    